import { loadStripe, Stripe } from '@stripe/stripe-js';

// Stripe publishable key - this should be set in your environment variables
// For development, you can use the test publishable key
// For production, use the live publishable key
const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '';

let stripePromise: Promise<Stripe | null> | null = null;
const stripeWithAccountPromises = new Map<string, Promise<Stripe | null>>();

export const getStripe = (): Promise<Stripe | null> => {
  if (!stripePromise) {
    stripePromise = loadStripe(STRIPE_PUBLISHABLE_KEY);
  }
  return stripePromise;
};

export const getStripeWithAccount = (stripeAccountId: string): Promise<Stripe | null> => {
  if (!stripeWithAccountPromises.has(stripeAccountId)) {
    const promise = loadStripe(STRIPE_PUBLISHABLE_KEY, {
      stripeAccount: stripeAccountId,
    });
    stripeWithAccountPromises.set(stripeAccountId, promise);
  }
  return stripeWithAccountPromises.get(stripeAccountId)!;
};

export const redirectToCheckout = async (sessionId: string): Promise<void> => {
  const stripe = await getStripe();
  
  if (!stripe) {
    throw new Error('Stripe failed to load');
  }

  const { error } = await stripe.redirectToCheckout({
    sessionId,
  });

  if (error) {
    throw error;
  }
}; 